// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-or-html-object{width:100%;min-height:12.5rem}`, "",{"version":3,"sources":["webpack://./src/components/common/ui-widgets/text-or-html.scss"],"names":[],"mappings":"AACA,qBACI,UAAA,CACA,kBAAA","sourcesContent":["/* Make the object as large as is needed */\n.text-or-html-object {\n    width: 100%;\n    min-height: 12.5rem; // 200px\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
